module.exports = __webpack_public_path__ + "static/img/third_content_1_h5.8549822.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/dec/third_content_1_h5.png
// module id = imy/
// module chunks = 34